import axios from "core/axios";
import { queryBuilder } from "utils/helpers";
import { MSG_PAGINATION_STEP, writingMessageType } from "./messagesTypes";

const msgBaseUrl = process.env.REACT_APP_MSG_URL

export default {
  getFolders: () => {
    return axios.get(`${msgBaseUrl}/messages/getFolders`, {
      headers: {
        "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getChatsInFolder: (id: number) => {
    return axios.get(`${msgBaseUrl}/messages/getChatsInFolder?idFolder=${encodeURIComponent(id)}`, {
      headers: {
        "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getMessagesFirst: (idUser: string) => {
    return axios.get(
      `${msgBaseUrl}/messages/getMessages?idUser=${idUser}&limit=${MSG_PAGINATION_STEP}`, {
        headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
        },
      }
    );
  },
  getMessagesMore: (idUser: string, idMessageCursor: number) => {
    return axios.get(
        `${msgBaseUrl}/messages/getMessages?idUser=${idUser}&idMessageCursor=${idMessageCursor}&limit=${MSG_PAGINATION_STEP}`, {
        headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
        },
      }
    );
  },
  archiveUser: (id: string) => {
      return axios.put(`${msgBaseUrl}/messages/addUserToArchive?idUser=${id}`, {}, {
        headers: {
            "Authorization": `Bearer ${window.localStorage.accessToken}`,
        },
      })
  },
  writeMessage: (writingMessage: writingMessageType, photos?: Array<File>) => {
      const query = queryBuilder(writingMessage)
      const formData = new FormData()
      Array.isArray(photos) && photos.forEach(el => {
          formData.append("profileImage", el)
      })
      return axios.post(`${msgBaseUrl}/messages/sendMessage?${query}`, formData, {
        headers: {
            "Authorization": `Bearer ${window.localStorage.accessToken}`,
            "Content-Type": "multipart/form-data",
        },
      })
  },
  readMessages: (messages: Array<number>, idUser: string) => {
    const query = messages.map(el=>`idMessages=${el}`).join("&")
    return axios.put(`${msgBaseUrl}/messages/readMessages?idUser=${idUser}&${query}`, {}, {
      headers: {
        "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  unArchiveUser: (id: string) => {
    return axios.delete(`${msgBaseUrl}/messages/deleteUserFromArchive?idUser=${id}`,  {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  getUserPreview: (id: string) => {
    return axios.get(`${msgBaseUrl}/messages/getUserPreviewMessage?idUser=${id}`,  {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  addToFavs: (id: string) => {
    return axios.put(`${msgBaseUrl}/messages/addUserToFavorites?idUser=${id}`, {}, {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  removeFromFavs: (id: string) => {
    return axios.delete(`${msgBaseUrl}/messages/deleteUserFromFavorites?idUser=${id}`,  {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  // Удаление сообщения — как deleteMessageRequest в приле.
  deleteMessage: (idUser: string, idMessages: number, deleteForAll: boolean) => {
    const query = queryBuilder({ idUser, idMessages, deleteForAll })
    return axios.delete(`${msgBaseUrl}/messages/deleteMessage?${query}`, {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  deleteDialog: (userId: string, both: boolean) => {
    return axios.delete(`${msgBaseUrl}/messages/deleteChat?idUser=${userId}&deleteForAll=${both}`, {
      headers: {
          "Authorization": `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  editMessage: (idUser: string, idMessage: number, newText: string) => {
      const queryParams = queryBuilder({idUser, idMessage, newText})
      return axios.put(`${msgBaseUrl}/messages/editMessage?${queryParams}`,  {},{
          headers: {
              "Authorization": `Bearer ${window.localStorage.accessToken}`
          }
      })
  }
};
